import {
  IWorkDefinition,
  IWorkDefinitionCreate,
  IWorkDefinitionUpdate
} from "@wingspanhq/payments/dist/interfaces";
import { WSService } from "../utils/WSService";

const service = new WSService("/payments/work-definition");

export async function createWorkDefinition(
  request: IWorkDefinitionCreate
): Promise<IWorkDefinition> {
  const { data } = await service.post("", request);
  return data;
}

export type ApiQueryListWorkDefinitions = {
  "filter[name][=]"?: string;
  "filter[userId][=]"?: string;
  "filter[workDefinitionId][in]"?: string[];

  "filter[createdAt][=]"?: Date;
  "filter[createdAt][>]"?: Date;
  "filter[createdAt][>=]"?: Date;
  "filter[createdAt][<]"?: Date;
  "filter[createdAt][<=]"?: Date;

  "filter[updatedAt][=]"?: Date;
  "filter[updatedAt][>]"?: Date;
  "filter[updatedAt][>=]"?: Date;
  "filter[updatedAt][<]"?: Date;
  "filter[updatedAt][<=]"?: Date;

  "filter[userRoles.viewerIds][=]"?: string;

  sort?: {
    createdAt?: "asc" | "desc";
    updatedAt?: "asc" | "desc";
    name?: "asc" | "desc";
  };

  page?: {
    size?: number;
    number?: number;
  };
};

export async function listWorkDefinitions(
  query?: ApiQueryListWorkDefinitions
): Promise<IWorkDefinition[]> {
  const { data } = await service.get("", { params: query });
  return data;
}

export async function getWorkDefinition(
  workDefinitionId: string
): Promise<IWorkDefinition> {
  const { data } = await service.get("/" + workDefinitionId);
  return data;
}

export async function updateWorkDefinition(
  workDefinitionId: string,
  request: IWorkDefinitionUpdate
): Promise<IWorkDefinition> {
  const { data } = await service.patch("/" + workDefinitionId, request);
  return data;
}
